import * as React from 'react';
import './Header.css';
import { AppStore } from '../../stores';
import { inject, observer } from 'mobx-react';

export interface IProps {
  headline: string;
  button?: any;
  headlineStyle?: any;
  appStore?: AppStore;
}

export interface IState {
}

@inject('appStore')
@observer
export default class Header extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (
      <div className='header'>
        <div
          className="headline"
          style={{
            width: this.props.appStore!.isMobile ? "100%" : "calc(100% - 500px)",
            ...this.props.headlineStyle
          }}
        >
          {this.props.headline}
        </div>
        {this.props.button &&
          <div
            className="headerAddButton"
            onClick={() => this.props.button.onClick()}
          >
            {this.props.button.title}
          </div>
        }
        {this.props.children &&
          <div
            className="headerContent"
          >
            {this.props.children}
          </div>
        }
        {!this.props.appStore!.user &&
          <div
            className="headerAddButton"
            onClick={() => this.props.appStore!.showWelcomepage = true}
          >
            {window.loc.strings.logIn}
          </div>
        }
      </div>
    );
  }

}